export default __webpack_public_path__ + "static/media/lessons-gold.859c5f76.svg";